export default __webpack_public_path__ + "images/8f912ed5534343022ee13ef63c90eec6-patients-scan.svg";